export default [
    {questionMessageId: 'faq.question.1', answerMessageId: 'faq.answer.1'},
    {questionMessageId: 'faq.question.2', answerMessageId: 'faq.answer.2'},
    {questionMessageId: 'faq.question.3', answerMessageId: 'faq.answer.3'},
    {questionMessageId: 'faq.question.4', answerMessageId: 'faq.answer.4'},
    {questionMessageId: 'faq.question.5', answerMessageId: 'faq.answer.5'},
    {questionMessageId: 'faq.question.6', answerMessageIds: ['faq.answer.6.1', 'faq.answer.6.2', 'faq.answer.6.3']},
    {questionMessageId: 'faq.question.7', answerMessageIds: ['faq.answer.7.1', 'faq.answer.7.2', 'faq.answer.7.3', 'faq.answer.7.4', 'faq.answer.7.5', 'faq.answer.7.6']},
    {questionMessageId: 'faq.question.8', answerMessageId: 'faq.answer.8'},
    {questionMessageId: 'faq.question.9', answerMessageId: 'faq.answer.9'},
    {questionMessageId: 'faq.question.10', answerMessageId: 'faq.answer.10'},
    {questionMessageId: 'faq.question.11', answerMessageId: 'faq.answer.11'},
    {questionMessageId: 'faq.question.12', answerMessageId: 'faq.answer.12'},
    {questionMessageId: 'faq.question.13', answerMessageId: 'faq.answer.13'},
    {questionMessageId: 'faq.question.14', answerMessageId: 'faq.answer.14'},
    {questionMessageId: 'faq.question.15', answerMessageId: 'faq.answer.15'},
    {questionMessageId: 'faq.question.16', answerMessageId: 'faq.answer.16'},
    {questionMessageId: 'faq.question.17', answerMessageIds: ['faq.answer.17.1', 'faq.answer.17.2']},
    {questionMessageId: 'faq.question.18', answerMessageId: 'faq.answer.18'},
]
